import { Box } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'
import { ProcurementSettingsPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import ApprovalsBlock from 'modules/approvals/components/ApprovalsConfigurationBlock'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { RequestTypeSettingsBlock } from 'modules/procurement/components/procurementTypes/RequestTypeSettingsBlock'
import NewProcurementSettingsContent from 'modules/procurement/components/settings/NewProcurementSettingsContent'
import SettingsCollectionsBootstrap from 'modules/procurement/lib/SettingsCollectionsBootstrap'

const PurchaseRequestsSettingsPage = () => {
  const { company } = useCurrentSession()

  const { data, error, loading } = useQuery(ProcurementSettingsPageDocument, {
    variables: {
      companyId: company.id,
      moduleId: AvailableModules.procurement,
      featureId: Features.procurement_purchase_requests,
    },
  })

  const canView = !!data?.procurement._policies.settingsManage.can
  const requestTypes = data?.procurement.typesConnection.nodes || []
  const purchaseRequestsfeatureEnabled =
    data?.companies.featureAvailabilitiesConnection.nodes[0]?.available ?? false
  const isProcurementV2FeatureEnabled = !!data?.features?.featuresConnection?.nodes?.some(
    (f) => f.name === 'procurement_v2' && f.enabled
  )
  const canReadTaskForms = data?.procurement?._policies?.procurementTaskFormRead?.can ?? false
  const isPoTemplatesFeatureEnabled = !!data?.features?.poTemplatesFeature?.nodes?.some(
    (f) => f.name === 'dev_procurement_po_templates' && f.enabled
  )

  return (
    <SettingsCollectionsBootstrap>
      <ResponsivePage.Body
        authorized={canView && purchaseRequestsfeatureEnabled}
        loading={loading}
        error={error}
        height="full"
      >
        {isProcurementV2FeatureEnabled ? (
          <NewProcurementSettingsContent
            canReadTaskForms={canReadTaskForms}
            canReadPoTemplates={isPoTemplatesFeatureEnabled}
          />
        ) : (
          <>
            <Box width="full" alignItems="flexEnd" justifyContent="flexEnd" paddingY="s24">
              <ApprovalsBlock
                noPadding
                category="purchases"
                title={i18n.t('procurement.purchase_requests.settings.approvals.title')}
                description={i18n.t('procurement.purchase_requests.settings.approvals.description')}
              />
            </Box>
            <RequestTypeSettingsBlock requestTypes={requestTypes} />
          </>
        )}
      </ResponsivePage.Body>
    </SettingsCollectionsBootstrap>
  )
}

export default PurchaseRequestsSettingsPage
